import React, { useEffect, useState } from "react";
import { getDomains, deleteDomain } from "../../api/domaines";

export default function DomainList({ onEdit }) {

  const [domains, setDomains] = useState([]);
  const [view, setView] = useState(null);

  const loadDomains = async (url) => {
    //console.log('csqs',url)
    const data = await getDomains(url);

    setDomains(data.items);
    setView(data.view);
  };
  useEffect(() => {
    loadDomains(); // page 1 par défaut
  }, []);
  return (
    <div className="admin-page">
      <div className="admin-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>Gestion des domaines</h2>
        <button className="fr-btn">+ Créer</button>
      </div>

      <p className="admin-page-count">
        {domains.length} domaine{domains.length > 1 ? "s" : ""}
      </p>

      <div className="table-responsive">
        <table className="table table-vcenter" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
          <tr style={{ borderBottom: "1px solid #e2e8f0" }}>
            <th className="admin-table-th">Domaine</th>
            <th className="admin-table-th">Fiches</th>
            <th className="admin-table-th">Abonnés</th>
            <th className="admin-table-th">Collège</th>
            <th className="admin-table-th">Sous-domaines</th>
            <th className="admin-table-th"></th>
          </tr>
          </thead>

          <tbody>
          {domains.map((d) => (
            <tr key={d.domId} className="admin-table-row">
              <td className="admin-table-td">{d.domLib}</td>
              <td className="admin-table-td">{d.domNbPrescripteurs}</td>
              <td className="admin-table-td">{d.domNbPrescripteurs}</td>
              <td className="admin-table-td">{d?.ste?.steLib}</td>
              <td className="admin-table-td"></td>
              <td className="admin-table-td" style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                <button className="fr-btn--secondary" onClick={() => onEdit(d)}>Modifier</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
